var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"tag",class:{clickable: _vm.clickable},on:{"click":function($event){return _vm.emitClick()}}},[_vm._v(_vm._s(_vm.tag)),(_vm.removable)?_c('span',{staticClass:"remove-tag clickable",on:{"click":function($event){return _vm.emitRemove()}}},[_vm._v("X")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }